/* eslint-disable import/prefer-default-export */

/**
 * planIds: ['standard', 'premium'];
 *
 * planFeaturesBefore: [{ ... , plansDetails: { standard: false , premium: false }}]
 * planFeaturesAfter: []
 */
export function excludeEmptyFeatures(plans, features) {
  if (plans.length === 0) return [];

  const planIds = plans.map((plan) => plan.planNameId);

  return features.filter(({ plansDetails }) => {
    if (!plansDetails) {
      return true;
    }

    const entries = Object.entries(plansDetails);
    const onlyDetailsForExistingPlans = entries.filter(([key]) => planIds.includes(key));

    // if the feature is disabled for all plans - remove the feature from the array
    return !onlyDetailsForExistingPlans.every(([, value]) => value === false);
  });
}
